import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const ChatListLoadable = loadable(async () => import('./ConversationList/conversation-list.view'), {
  fallback: <FullPageLoading />,
});
